const teamRoles = ["staff", "admin", "owner"];
const adminRoles = ["admin", "owner"];

export const staffNavigationGroups = [
  {
    id: "wireless",
    label: "Wireless & service",
    links: [
      { to: "/lines", label: "Lines" },
      { to: "/service-requests", label: "Service requests", serviceRequests: true },
      { to: "/travel-esims", label: "Travel eSIMs", roles: teamRoles },
      { to: "/plans", label: "Plan Templates" },
    ],
  },
  {
    id: "inventory",
    label: "Inventory & repairs",
    links: [
      { to: "/inventory", label: "Inventory" },
      { to: "/repairs", label: "Repairs" },
      { to: "/parts", label: "Parts" },
      { to: "/shipments", label: "Shipments", roles: teamRoles },
      { to: "/purchase-orders", label: "Purchase Orders" },
      { to: "/quotes", label: "Upgrades & Trade-ins" },
    ],
  },
  {
    id: "finance",
    label: "Payments & finance",
    links: [
      { to: "/payments", label: "Payments" },
      { to: "/finance", label: "Finance" },
      { to: "/collections", label: "Collections" },
      { to: "/ledger", label: "Ledger" },
    ],
  },
  {
    id: "growth",
    label: "Growth & messages",
    links: [
      { to: "/promotions", label: "Promotions" },
      { to: "/rewards", label: "Rewards" },
      { to: "/reminders", label: "Reminders" },
      { to: "/messages", label: "Messages" },
    ],
  },
  {
    id: "admin",
    label: "Administration",
    links: [
      { to: "/admin", label: "Admin Center", roles: adminRoles },
      { to: "/profitability", label: "Profitability", roles: adminRoles },
      { to: "/financial-ledger", label: "Financial Ledger", roles: adminRoles },
      { to: "/carrier-costs", label: "Carrier Costs", roles: adminRoles },
    ],
  },
];

export function visibleStaffNavigation(role) {
  return staffNavigationGroups.map(group => ({
    ...group,
    links: group.links.filter(link => !link.roles || link.roles.includes(role)),
  })).filter(group => group.links.length);
}

export function staffLinkMatches(pathname, to) {
  return pathname === to || pathname.startsWith(`${to}/`);
}
